import { Snowflake, Wifi, Car, Waves, CookingPot, Zap, ShieldCheck, Droplets, Tv } from "lucide-react";
import api from "@/lib/api";

export const pathAfterLogin = (fallback = "/") =>
  api.get("/residences/host/me").then((r) => (r.data.host ? "/mon-espace-hote" : fallback)).catch(() => fallback);

export const AMENITY_ICONS = {
  climatisation: Snowflake, wifi: Wifi, parking: Car, piscine: Waves, cuisine: CookingPot,
  groupe: Zap, securite: ShieldCheck, eau_chaude: Droplets, tv: Tv,
};

export const BOOKING_STATUS = {
  pending: { label: "En attente", cls: "bg-[#FFC857]/25 text-[#8a6a12]" },
  accepted: { label: "Acceptée", cls: "bg-[#38B5D8]/20 text-[#0e6f8c]" },
  confirmed: { label: "Confirmée", cls: "bg-emerald-100 text-emerald-700" },
  refused: { label: "Refusée", cls: "bg-red-100 text-red-700" },
  cancelled: { label: "Annulée", cls: "bg-slate-200 text-slate-600" },
  completed: { label: "Terminée", cls: "bg-[#123B4A]/10 text-[#123B4A]" },
};

export const LISTING_STATUS = {
  draft: { label: "Brouillon", cls: "bg-slate-200 text-slate-700" },
  pending: { label: "En attente de validation", cls: "bg-[#FFC857]/25 text-[#8a6a12]" },
  published: { label: "Publiée", cls: "bg-emerald-100 text-emerald-700" },
  rejected: { label: "Refusée", cls: "bg-red-100 text-red-700" },
  suspended: { label: "Suspendue", cls: "bg-red-100 text-red-700" },
  disabled: { label: "Désactivée", cls: "bg-slate-200 text-slate-600" },
  deleted: { label: "Supprimée", cls: "bg-slate-200 text-slate-500" },
};

export const NO_PAYMENT_MSG = "La réservation sur Babimix est gratuite. Le paiement du séjour se règle directement avec le propriétaire, selon les conditions convenues entre les deux parties. Babimix n'encaisse aucun paiement pour les réservations.";

export const StatusPill = ({ map, status, testid }) => {
  const s = map[status] || { label: status, cls: "bg-slate-200 text-slate-700" };
  return <span data-testid={testid} className={`inline-block text-[11px] font-bold px-2.5 py-1 rounded-full ${s.cls}`}>{s.label}</span>;
};

export const cityName = (meta, slug) => meta?.cities?.find((c) => c.slug === slug)?.name || (slug || "").replace(/-/g, " ");
export const communeName = (meta, slug) => meta?.communes?.find((c) => c.slug === slug)?.name || (slug || "").replace(/-/g, " ");
export const typeName = (meta, slug) => meta?.types?.find((t) => t.slug === slug)?.name || slug;
export const fmtDate = (d) => (d ? new Date(`${d}T12:00:00`).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" }) : "");
export const todayISO = () => new Date().toISOString().slice(0, 10);
export const addDaysISO = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
export const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const daysLeft = (iso) => (iso ? Math.max(0, Math.ceil((new Date(iso) - Date.now()) / 86400000)) : 0);
export const daysLeftLabel = (iso) => { const n = daysLeft(iso); return n > 1 ? `${n} jours restants` : n === 1 ? "Dernier jour" : ""; };
